<template>
  <thread-form-group v-if="documentName" label="Generated document name (to protect PII)">
    <input type="text" class="thread-hashed-filename__input form-control" :value="documentName" disabled />
  </thread-form-group>
</template>

<script>
import ThreadFormGroup from "@/components/common/thread-form-group.vue";

export default {
  name: "ThreadHashedFilename",
  components: { ThreadFormGroup },
  props: {
    documentName: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped lang="scss">
.thread-hashed-filename__input {
  background-color: rgba(145, 158, 171, 0.08) !important;
  color: #919eabcc;
  border: 1px solid rgba(228, 232, 235, 0.2);
  cursor: not-allowed;
}
</style>
